import { Vars } from './../model/vars';
import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';
import { BaseReportService } from '../../shared/_utils/services/base-report-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';  
import { Observable } from 'rxjs/Observable';
import { map , tap} from 'rxjs/operators'; 
import { ExecutingUnit } from '../entities/executingUnit'; 
import { ResponsePageable } from '../../shared/_utils/services/responsePageable'; 
import { CostCenter } from '../entities/costCenter';   
import { ParamsReportVacationPeriods } from './../model/params-report-vacation-periods'; 
import { VacationPeriodsDTO } from '../model/vacation-periods-dto';

interface ExtraSearchFields { 
  //object? :any;
  //executingUnit?: ExecutingUnit,   
  //costCenter : CostCenter, 
}

@Injectable()
export class ReportVacationPeriodsService extends BaseReportService<VacationPeriodsDTO> {

  public uri = '/api/reportVacationPeriods/';

  constructor(injector: Injector) {
    super(injector); 
  }
  
  buildSentence(entity?: VacationPeriodsDTO, event?: LazyLoadEvent, extraSearchFields?: ExtraSearchFields): HttpParams {
   /* if (entity || extraSearchFields) {
      let query = '';
      query = query.concat(
        extraSearchFields && extraSearchFields.executingUnit ?
          `executingUnit.id${QueryOperator.Equal}${extraSearchFields.executingUnit.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      
      query = query.concat(
        extraSearchFields && extraSearchFields.employeeType ?
          `employeeType.id${QueryOperator.Equal}${extraSearchFields.employeeType.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        extraSearchFields && extraSearchFields.startDate  ?
          // tslint:disable-next-line:max-line-length
          `checkOutTime${QueryOperator.GreaterThanOrEqual}${extraSearchFields.startDateRange01.toISOString()}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        extraSearchFields && extraSearchFields.startDateRange02 ?
          // tslint:disable-next-line:max-line-length
          `checkInTime${QueryOperator.LessThanOrEqual}${extraSearchFields.startDateRange02.toISOString()}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
 
      query = query.concat(
        extraSearchFields && extraSearchFields.absenceType ?
          // tslint:disable-next-line:max-line-length
          `absenceType.id${QueryOperator.Equal}${extraSearchFields.absenceType.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
       );

      query = query.concat(
        extraSearchFields && extraSearchFields.costCenter ?
          // tslint:disable-next-line:max-line-length
          `costCenter.id${QueryOperator.Equal}${extraSearchFields.costCenter.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      ); 
      //console.log(query);
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
      

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;*/
    return null; 
  } 
  
  searchToReport(entity?: VacationPeriodsDTO, event?: LazyLoadEvent,
    extraSearchFields?: ExtraSearchFields): Observable<ResponsePageable<VacationPeriodsDTO>> {

    const url = `${this.rutaServidor}${this.uri}search`;
    this.spinnerService.showAll();
    const httpParams = this.buildSentence(entity, event, extraSearchFields);
    return this.httpClient.get<ResponsePageable<VacationPeriodsDTO>>(url, { params: httpParams })
      .pipe(
        tap(response => {
          if (response.numberOfElements > 0) {
            response.content.forEach((value) => {
              // debugger;
              this.convertToDate(value);
            })
          } 
          this.spinnerService.hideAll();
          return response;
        })
      );
  }
 

  searchToViewTable( paramsReportVacationPeriods : ParamsReportVacationPeriods): Observable<any> {
         this.spinnerService.showAll();
        const url = `${this.rutaServidor}${this.uri}search`; 
        return this.httpClient.post<any>(url, paramsReportVacationPeriods  )
        .pipe(
          tap(response => {
            this.spinnerService.hideAll();
            return response;
          }
          ,
          error => {console.log(error);
          this.spinnerService.hideAll();})
       );
  } 

  searchFiscalYear(): Observable<any> {
    this.spinnerService.showAll();
   const url = `${this.rutaServidor}${this.uri}searchFiscalYear`; 
   return this.httpClient.get<any>(url)
   .pipe(
     tap(response => {
       this.spinnerService.hideAll();
       return response;
     }
     ,
     error => {console.log(error);
     this.spinnerService.hideAll();})
  );
} 
}



// WEBPACK FOOTER //
// ./src/app/core/services/report-vacation-periods.service.ts